var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTierhubLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UPV"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.97312 44.2654H0V40.9507H13.542V44.2654H8.56887V57.2937H4.97312V44.2654Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.796 40.9507H22.3917V57.2947H18.796V40.9507Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.8112 40.9507H41.1385V44.1491H32.3833V47.4648H40.0885V50.6632H32.3833V54.0953H41.2558V57.2937H28.8112V40.9507Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46.7891 40.9507H54.2607C56.339 40.9507 57.9264 41.5107 59.0238 42.608C59.9574 43.5417 60.4248 44.7791 60.4248 46.3438V46.3901C60.4248 49.0285 59.0001 50.6859 56.9227 51.4569L60.9148 57.2937H56.7117L53.2096 52.0632H50.3849V57.2937H46.7891V40.9507ZM54.027 48.8885C55.8017 48.8885 56.7817 47.9775 56.7817 46.5775V46.5301C56.7817 44.9654 55.7307 44.1954 53.957 44.1954H50.3849V48.8885H54.027Z",
    fill: "#080808"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Slogan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.752 62.5236H17.0449V65.5831H20.5573V62.5236H21.8502V69.884H20.5573V66.7823H17.0449V69.884H15.752V62.5236Z",
    fill: "url(#paint0_linear_409_9985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.3075 66.7612V62.5242H28.6005V66.7088C28.6005 68.0861 29.2943 68.8016 30.4617 68.8016C31.6074 68.8016 32.3126 68.118 32.3126 66.7612V62.5242H33.6055V66.6985C33.6055 68.8963 32.3651 69.9998 30.4401 69.9998C28.5377 69.9998 27.3075 68.8952 27.3075 66.7612Z",
    fill: "url(#paint1_linear_409_9985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.0641 62.5236H42.3654C43.2168 62.5236 43.8581 62.7439 44.2894 63.1752C44.6157 63.5016 44.7835 63.9113 44.7835 64.3951V64.4157C44.7835 65.3092 44.2791 65.7725 43.7325 66.0556C44.6055 66.3603 45.1943 66.8338 45.1943 67.8436V67.8642C45.1943 69.1788 44.1113 69.8829 42.4704 69.8829H39.0631V62.5236H39.0641ZM43.4916 64.6061C43.4916 64.0173 43.0397 63.6704 42.1987 63.6704H40.3375V65.6263H42.104C42.945 65.6263 43.4916 65.3 43.4916 64.6277V64.6061ZM43.9013 67.7078C43.9013 67.0767 43.4072 66.7195 42.3871 66.7195H40.3365V68.7382H42.4818C43.365 68.7382 43.9013 68.4016 43.9013 67.7284V67.7078Z",
    fill: "url(#paint2_linear_409_9985)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M35.5893 24.5853C35.0231 24.5853 34.4744 24.2827 34.1862 23.7504C34.1255 23.6382 33.5819 22.614 33.2237 21.2345C32.6956 19.2025 32.848 17.4031 33.6643 16.0298C35.2836 13.3029 37.8324 13.1454 39.8809 13.0177C41.2377 12.9333 42.5204 12.8541 43.5673 12.117C46.1995 10.2651 46.252 7.25197 45.831 5.04696C44.6821 5.93844 43.1648 6.52418 41.3705 6.73829C40.6643 6.82271 39.8212 6.81344 38.9277 6.80315C36.4139 6.77535 33.2855 6.74035 32.0944 8.71375C31.6405 9.46625 30.6625 9.70816 29.91 9.25419C29.1575 8.80022 28.9156 7.82227 29.3696 7.06977C31.5005 3.53681 35.9908 3.58725 38.9637 3.62019C39.7502 3.62945 40.4934 3.63769 40.9948 3.57798C42.2043 3.43386 44.3198 2.92224 44.8932 1.1115C45.0908 0.488701 45.6488 0.0491385 46.3004 0.00384417C46.952 -0.0414502 47.5655 0.316788 47.8466 0.905615C47.8898 0.996204 48.9069 3.15283 49.157 5.86329C49.5091 9.68037 48.21 12.7429 45.3986 14.7204C43.6157 15.9742 41.6546 16.0967 40.0786 16.1945C38.1083 16.317 37.1293 16.4303 36.4015 17.6553C35.6006 19.0028 36.5817 21.4775 36.9883 22.2382C37.4072 23.0113 37.119 23.9749 36.3459 24.3938C36.104 24.5235 35.8446 24.5853 35.5893 24.5853Z",
    fill: "url(#paint3_linear_409_9985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.8757 24.5845C25.6194 24.5845 25.36 24.5227 25.1191 24.392C24.347 23.974 24.0598 23.0105 24.4757 22.2384C24.8823 21.4777 25.8623 19.003 25.0625 17.6565C24.3347 16.4315 23.3557 16.3182 21.3854 16.1957C19.8094 16.098 17.8483 15.9765 16.0654 14.7216C13.254 12.7441 11.9549 9.6816 12.307 5.86452C12.5571 3.15406 13.5742 0.997432 13.6174 0.906843C13.8984 0.316987 14.512 -0.04022 15.1636 0.00507431C15.8152 0.0503687 16.3732 0.489929 16.5708 1.11273C17.1442 2.92347 19.2586 3.43509 20.4692 3.57921C20.9705 3.63892 21.7127 3.63068 22.5003 3.62142C25.4722 3.58847 29.9635 3.53803 32.0944 7.071C32.5484 7.8235 32.3065 8.80145 31.554 9.25542C30.8015 9.70939 29.8235 9.46748 29.3696 8.71498C28.1785 6.74158 25.0501 6.77658 22.5363 6.80438C21.6438 6.81467 20.7997 6.82394 20.0935 6.73952C18.3013 6.52643 16.7839 5.94069 15.6351 5.05025C15.563 5.42599 15.5043 5.82437 15.4693 6.23717C15.248 8.85086 16.0643 10.8304 17.8967 12.1182C18.9436 12.8543 20.2252 12.9346 21.583 13.019C23.6306 13.1456 26.1794 13.3041 27.7997 16.031C28.616 17.4043 28.7673 19.2047 28.2403 21.2358C27.882 22.6152 27.3385 23.6395 27.2778 23.7517C26.9885 24.2818 26.4409 24.5845 25.8757 24.5845Z",
    fill: "url(#paint4_linear_409_9985)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M44.5024 33.2653C41.8548 33.2653 39.3739 32.1577 37.6166 30.2728C35.8584 32.1577 33.3785 33.2653 30.7309 33.2653C28.0832 33.2653 25.6023 32.1577 23.8451 30.2728C22.0868 32.1577 19.607 33.2653 16.9593 33.2653C16.0802 33.2653 15.3678 32.553 15.3678 31.6738C15.3678 30.7947 16.0802 30.0824 16.9593 30.0824C19.2508 30.0824 21.3539 28.8285 22.4461 26.8098C22.7241 26.2962 23.2614 25.976 23.8461 25.976C24.4308 25.976 24.9682 26.2962 25.2461 26.8098C26.3383 28.8285 28.4404 30.0824 30.7329 30.0824C33.0244 30.0824 35.1275 28.8285 36.2197 26.8098C36.4977 26.2962 37.035 25.976 37.6197 25.976C38.2044 25.976 38.7418 26.2962 39.0197 26.8098C40.1119 28.8285 42.214 30.0824 44.5065 30.0824C45.3857 30.0824 46.098 30.7947 46.098 31.6738C46.098 32.553 45.3815 33.2653 44.5024 33.2653Z",
    fill: "url(#paint5_linear_409_9985)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_409_9985",
    x1: 15.5463,
    y1: 66.2043,
    x2: 44.8422,
    y2: 66.2043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_409_9985",
    x1: 15.5457,
    y1: 66.2617,
    x2: 44.8416,
    y2: 66.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_409_9985",
    x1: 15.5463,
    y1: 66.2043,
    x2: 44.8422,
    y2: 66.2043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_409_9985",
    x1: 14.7667,
    y1: 31.4384,
    x2: 46.9325,
    y2: 3.2077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_409_9985",
    x1: 7.75398,
    y1: 23.4483,
    x2: 39.9198,
    y2: -4.78231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_409_9985",
    x1: 21.8292,
    y1: 39.4861,
    x2: 53.9951,
    y2: 11.2554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierhubLogo);
export default __webpack_public_path__ + "static/media/tierhub-logo.a7e3ecd484142581b8bf6c07c40488d6.svg";
export { ForwardRef as ReactComponent };